import React from 'react';
import BaseCard from './BaseCard';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import CardHeader from './CardHeader';
import DataTable from '../../../../Elements/DataTable/DataTableFigma';
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import moneyHelper from '../../../../Helpers/moneyHelper';

class OtherDirectCostsCard extends BaseCard {
  labelAndType = [
    { label: 'Platform Cost', type: 'SM', statusCodes: null, serviceTypeCodes: null },
    { label: 'Call Recording Cost', type: 'Vocazilla', statusCodes: null, serviceTypeCodes: null },
    { label: 'IWR/CSAT Cost', type: 'ICRFee', statusCodes: [2], serviceTypeCodes: [7] },
    { label: 'IVR Cost', type: 'IVRFee', statusCodes: [2], serviceTypeCodes: [10] },
  ];

  renderHeaderDataTable() {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInFirstDataTable,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Header'
        thereIsNoSuchRowMessageCheck={false}
        smallDataTable={true}
      />
    );
  }

  renderCostDataTable(costType) {
    if (
      costType.statusCodes === null ||
      costType.statusCodes.includes(this.props.Tier.PricingDetails.StatusCode) ||
      costType.serviceTypeCodes === null ||
      costType.serviceTypeCodes.includes(this.props.Tier.PricingDetails.ServiceTypeCode)
    ) {
      return (
        <DataTable
          type={{
            FieldsToShowInDataTable: () => this.FieldsToShowInDataTableByCostType(costType.label, costType.type),
            NameOfTheIdField: () => 'TierId',
            FieldsToShowInListTable: [],
            MoneyFields: this.MoneyFields,
            Currency: this.Currency,
          }}
          itemList={this.props.Tier}
          renderInputFieldFunction={this.renderInputField}
          DataTableType='Body'
          smallDataTable={true}
          key={`${costType.type}DataTable`}
        />
      );
    }
    return null;
  }

  renderOverHeadRateDataTable() {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableOverheadRate,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={this.props.Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderFooterDataTable() {
    return (
      <footer>
        <DataTable
          type={{
            FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
            NameOfTheIdField: () => 'TierId',
            FieldsToShowInListTable: [],
            MoneyFields: this.MoneyFields,
            Currency: this.Currency,
          }}
          headeritemList={this.props.Tier}
          thereIsNoSuchRowMessageCheck={false}
          smallDataTable={true}
        />
      </footer>
    );
  }

  render() {
    return (
      <div className='card'>
        <CardHeader
          bodyactive={this.state.bodyactive}
          changeBodyStatus={this.changeBodyStatus}
          sectionNumber={'8'}
          HeaderText={'OTHER DIRECT COSTS'}
          subtotal={moneyHelper.toMoneyFormat(this.props.Tier.OtherCostTotal, this.props.Tier.PricingDetails.CurrencyCode)}
          subtotalRev={this.props.Tier.OtherCostPct + ' of revenue'}
        />
        {this.state.bodyactive ? (
          <div>
            {this.renderHeaderDataTable()}
            {this.labelAndType.map((costType) => this.renderCostDataTable(costType))}
            {this.renderOverHeadRateDataTable()}
          </div>
        ) : null}
        {this.renderFooterDataTable()}
      </div>
    );
  }

  FieldsToShowInFirstDataTable() {
    return [
      { label: ' ', tableminWidth: '375px', headerPosition: 'header-text-right' },
      { label: 'Override', tableminWidth: '125px' },
      { label: 'Per Evaluation', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Per cycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Annually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '% of revenues', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  FieldsToShowInDataTableByCostType(label, type) {
    return [
      { label, data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '375px' },
      {
        label: 'Is Overrid',
        // SMCostPerEvalOverride
        data: `${type}CostPerEvalOverride`,
        type: type === 'SM' ? InputTypesEnum.SingleCheckBox : InputTypesEnum.TextReadOnly,
        fieldClass: ' ',
        tableminWidth: '125px',
      },
      this.GetOverrideField(type),
      { data: `${type}CostPerCycle`, tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: `${type}CostAnnually`, tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: `${type}CostPct`,
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  GetOverrideField(type) {
    // SMCostPerEvalOverride
    return this.props.Tier.PricingDetails[`${type}CostPerEvalOverride`]
      ? {
          label: 'Override value',
          data: `${type}CostPerEvalConv`,
          type: InputTypesEnum.NumberWithTwoDecimalPlaces2,
          tableminWidth: '125px',
          headerPosition: 'header-text-right',
        }
      : {
          label: 'Override value',
          data: (item) => moneyHelper.toMoneyFormat(item[`${type}CostPerEvalConv`], item.CurrencyCode),
          type: InputTypesEnum.TextReadOnly,
          tableminWidth: '125px',
          headerPosition: 'header-text-right',
        };
  }

  // FieldsToShowInDataTableSurfMerchantsCost() {
  //   return [
  //     { label: 'Surf Merchants Cost', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '500px' },
  //     { data: 'SMCostPerEvalConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     { data: 'SMCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     { data: 'SMCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     {
  //       data: 'SMCostPct',
  //       type: InputTypesEnum.TextReadOnly,
  //       tableminWidth: '125px',
  //       headerPosition: 'header-text-right',
  //     },
  //   ];
  // }
  // FieldsToShowInDataTableVocazillaCost() {
  //   return [
  //     { label: 'Vocazilla Cost', data: '', tableminWidth: '500px' },
  //     { data: 'VocazillaCostPerEvalConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     { data: 'VocazillaCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     { data: 'VocazillaCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     {
  //       data: 'VocazillaCostPct',
  //       type: InputTypesEnum.TextReadOnly,
  //       tableminWidth: '125px',
  //       headerPosition: 'header-text-right',
  //     },
  //   ];
  // }
  // FieldsToShowInDataTableIVRCost() {
  //   return [
  //     { label: 'IVR Cost', data: '', tableminWidth: '500px' },
  //     {
  //       data: 'IVRFeeCostPerEvalConv',
  //       type: InputTypesEnum.TextReadOnly,
  //       tableminWidth: '125px',
  //       headerPosition: 'header-text-right',
  //     },
  //     { data: 'IVRFeeCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     { data: 'IVRFeeCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     {
  //       data: 'IVRFeeCostPct',
  //       type: InputTypesEnum.TextReadOnly,
  //       tableminWidth: '125px',
  //       headerPosition: 'header-text-right',
  //     },
  //   ];
  // }

  // FieldsToShowInDataTableICRCost() {
  //   return [
  //     { label: 'ICR Cost', data: '', tableminWidth: '500px' },
  //     {
  //       data: 'ICRFeeCostPerEvalConv',
  //       type: InputTypesEnum.TextReadOnly,
  //       tableminWidth: '125px',
  //       headerPosition: 'header-text-right',
  //     },
  //     { data: 'ICRFeeCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     { data: 'ICRFeeCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
  //     {
  //       data: 'ICRFeeCostPct',
  //       type: InputTypesEnum.TextReadOnly,
  //       tableminWidth: '125px',
  //       headerPosition: 'header-text-right',
  //     },
  //   ];
  // }

  FieldsToShowInDataTableOverheadRate() {
    return [
      { label: 'Overhead Rate (12 mo avg)', type: FieldTypesEnum.JustLabel, data: '', tableminWidth: '500px' },
      {
        data: 'OverheadRatePct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: ' ',
        data: ' ',
        type: FieldTypesEnum.EmptySpace,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { data: 'OverheadRateAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'OverheadRateCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInFooterDataTable() {
    return [
      { label: 'TOTAL OTHER COST', tableminWidth: '750px', headerPosition: 'header-text-right' },
      { label: '', data: 'OtherCostTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'OtherCostPct', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }
}

export default OtherDirectCostsCard;
